import React from "react";
import "./Header.scss";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { selectUser, selectAuthStatus } from "../../store/authSlice"; // Assurez-vous que ces chemins sont corrects
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../store/authSlice"; // Importer la fonction de déconnexion
import { ToastContainer, toast } from "react-toastify"; // Importer ToastContainer et toast
import "react-toastify/dist/ReactToastify.css"; // Importer les styles par défaut de Toastify
import navbarfond from "../../assets/images/navbarfond.jpg"


const Header = () => {
  const user = useSelector(selectUser);
  const authStatus = useSelector(selectAuthStatus);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser());
    toast.success("Successful disconnection !");

    // Utiliser un délai avant de rediriger
    setTimeout(() => {
      navigate("/");
    }, 2000); // 2 secondes
  };

  // console.log('User:', user);

  return (
    <header className="header text-white">
      <ToastContainer
        position="top-right" // Positionner les toasts en haut à droite
        autoClose={3000} // Durée d'affichage du toast
        hideProgressBar={true} // Cacher la barre de progression
        closeOnClick={true} // Fermer le toast au clic
        pauseOnHover={true} // Mettre le toast en pause au survol
        draggable={false} // Désactiver le glissement
      />
      <div className="container">
        <div className="header-cnt">
          <div className="header-cnt-top fs-13 py-2 flex align-center justify-between">
            {user ? (
              <>
                <div className="header-cnt-top-l">
                  <ul className="flex top-links align-center">
                    <li className="flex align-center">
                      {/* <span className="fs-13">Follow us on</span> */}
                      <ul className="social-links flex align-center">
                        {/* <li className="mx-2">
                          <a href="https://www.facebook.com" className="fs-15">
                            <i className="fab fa-facebook"></i>
                          </a>
                        </li>
                        <li className="mx-2">
                          <a href="https://www.instagram.com" className="fs-15">
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li> */}
                        <li className="mx-2 flex items-center">
                          <img
                            src={navbarfond}
                            className="mr-2"
                            style={{ width: "100px", height: "40px" }}
                          />
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div className="header-cnt-top-r">
                  <ul className="top-links flex align-center">
                    <li>
                      <Link to="/contact" className="top-link-itm">
                        <span className="top-link-itm-ico mx-2">
                          <i className="fa-solid fa-circle-question"></i>
                        </span>
                        <span className="top-link-itm-txt">Support</span>
                      </Link>
                    </li>
                    <li className="vert-line"></li>
                    
                    <li>
                      <Link to="/user/accountsettings" className="top-link-itm">
                        <span className="top-link-itm-ico mx-2">
                          <i className="fa fa-user"></i>
                        </span>
                        <span className="top-link-itm-txt">Profile</span>
                      </Link>
                    </li>
                    <li className="vert-line"></li>
                    <li>
                      <button className="top-link-itm" onClick={handleLogout}>
                        <span className="top-link-itm-ico mx-2">
                          <i
                            className="fa fa-sign-out-alt"
                            style={{ fontSize: "14px", color: "white" }}
                          ></i>
                        </span>
                        <span
                          className="top-link-itm-txt"
                          style={{ fontSize: "14px", color: "white" }}
                        >
                          Logout
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>
              </>
            ) : (
              <>
                <div className="header-cnt-top-l">
                  <ul className="flex top-links align-center">
                    <li className="flex align-center">
                      {/* <span className="fs-13">Follow us on</span> */}
                      <ul className="social-links flex align-center">
                        {/* <li className="mx-2">
                          <a href="www.facebook.com" className="fs-15">
                            <i className="fab fa-facebook"></i>
                          </a>
                        </li>
                        <li className="mx-2">
                          <a href="www.instagram.com" className="fs-15">
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li> */}
                        <li className="mx-2 flex items-center">
                          <img
                            src={navbarfond}
                            className="mr-2"
                            style={{ width: "100px", height: "40px" }}
                          />
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div className="header-cnt-top-r">
                  <ul className="top-links flex align-center">
                    <li>
                      <Link to="/contact" className="top-link-itm">
                        <span className="top-link-itm-ico mx-2">
                          <i className="fa-solid fa-circle-question"></i>
                        </span>
                        <span className="top-link-itm-txt">Support</span>
                      </Link>
                    </li>
                    <li className="vert-line"></li>
                    <li>
                      <Link to="/login">
                        <span className="top-link-itm-ico mx-2">
                          <i className="fa fa-sign-in"></i>
                        </span>
                        <span className="top-link-itm-txt">Log in</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>

          <div className="header-cnt-bottom">
            <Navbar />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
